import { format } from 'date-fns';

export function readableDate(iso) {
    return iso ? format(new Date(iso), 'P') : '';
}

export function saveableDate(iso) {
    return readableDate(iso);
}
